module.exports = __webpack_public_path__ + "static/media/ProjectBoard.5977957d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ProjectBoard.jpeg
// module id = 456
// module chunks = 7